module.exports = __webpack_public_path__ + "static/media/Medidas_3_4_5_6_7.21c207bd.pdf";